import React, { useContext } from "react";
import { Menu } from "antd";
import { Link } from "react-router-dom";

import CustomScrollbars from "util/CustomScrollbars";
import SidebarLogo from "./SidebarLogo";
import UserProfile from "./UserProfile";
import AppsNavigation from "./AppsNavigation";

import { context } from '../../context';

import styles from './index.module.scss';

const SubMenu = Menu.SubMenu;
const MenuItemGroup = Menu.ItemGroup;

const SidebarContent = () => {

  const { state } = useContext(context);

  const { pathname } = state

  const selectedKeys = pathname.substr(1);
  const defaultOpenKeys = selectedKeys.split('/')[1];

  return (
    <>
      <SidebarLogo />
      <div className="gx-sidebar-content">
        <CustomScrollbars className="gx-layout-sider-scrollbar">
          <Menu
            defaultOpenKeys={[defaultOpenKeys]}
            selectedKeys={[selectedKeys]}
            theme={'dark'}
            mode="inline">

            <MenuItemGroup key="users" className="gx-menu-group" title="Gestión de Usuarios">
              <Menu.Item key="usuarios/empleados">
                <Link to="/usuarios/empleados">
                  <i className="icon icon-profile2" />
                  <span>Empleados</span></Link>
              </Menu.Item>
            </MenuItemGroup>

            <MenuItemGroup key="material" className="gx-menu-group" title="Gestión de Material">
              <Menu.Item key="material/especialidades">
                <Link to="/material/especialidades">
                  <i className="icon icon-profile2" />
                  <span>Especialidades</span></Link>
              </Menu.Item>
            </MenuItemGroup>

            <MenuItemGroup key="main" className="gx-menu-group" title="Main">

              <Menu.Item key="social-apps/profile">
                <Link to="/social-apps/profile">
                  <i className="icon icon-profile2" />
                  <span>Profile</span>
                </Link>
              </Menu.Item>

            </MenuItemGroup>

            <MenuItemGroup key="custom-views" className="gx-menu-group"
              title="Custom Views">

              <SubMenu key="user-auth"
                title={<span><i className="icon icon-auth-screen" /><span>User Auth</span></span>}>

                <Menu.Item key="custom-views/user-auth/sign-in">
                  <Link to="/custom-views/user-auth/sign-in">
                    <span>Sign In</span></Link>
                </Menu.Item>

                <Menu.Item key="custom-views/user-auth/forgot-password">
                  <Link to="/custom-views/user-auth/forgot-password">
                    <span>Forgot Password</span></Link>
                </Menu.Item>

                <Menu.Item key="custom-views/user-auth/sign-up">
                  <Link to="/custom-views/user-auth/sign-up">
                    <span>Sign Up</span></Link>
                </Menu.Item>

                <Menu.Item key="custom-views/user-auth/lock-screen">
                  <Link to="/custom-views/user-auth/lock-screen">
                    <span>Lock Screen</span></Link>
                </Menu.Item>

                <Menu.Item key="custom-views/user-auth/reset-password">
                  <Link to="/custom-views/user-auth/reset-password">
                    <span>Reset Password</span></Link>
                </Menu.Item>
              </SubMenu>

            </MenuItemGroup>

            {/* <MenuItemGroup key="cerrar" className="gx-menu-group"
              title="Cerrar sesión" /> */}

          </Menu>
        </CustomScrollbars>
      </div>
    </>
  );
};
export default SidebarContent;

